export const TICKET_METRICS_DATA = {
  meanTimeToResolution: '15 Days',
  ticketsPending: 4,
  ticketsClosed: 5,
  ticketsDeferred: 1,
  ticketsWorkInProgress: 1
};

export const EFFORT_TYPES_DATA = [
  {
    id: 'high',
    type: 'High',
    level: 'H',
    effort: 2,
    color: 'red',
    borderColor: '#dc2626'
  },
  {
    id: 'medium',
    type: 'Medium',
    level: 'M',
    effort: 4,
    color: 'orange',
    borderColor: '#ea580c'
  },
  {
    id: 'low',
    type: 'Low',
    level: 'L',
    effort: 3,
    color: 'green',
    borderColor: '#16a34a'
  }
];

export const TICKET_DETAILS_DATA = [
  {
    id: 'RC-2043',
    title: 'Increase memory allocation to 16GB',
    description: 'Memory usage trend shows 80% spike last 7 days',
    effortType: 'medium',
    status: 'pending',
    effort: 'Medium Effort',
    system: 'SAP',
    statusType: 'PENDING'
  },
  {
    id: 'RC-2044',
    title: 'Update database indices',
    description: 'Query performance degraded by 45% over 14 days',
    effortType: 'low',
    status: 'pending',
    effort: 'Low Effort',
    system: 'Infra',
    statusType: 'PENDING'
  },
  {
    id: 'RC-2045',
    title: 'Implement load balancer configuration',
    description: 'CPU utilization consistently above 85%',
    effortType: 'low',
    status: 'pending',
    effort: 'Low Effort',
    system: 'SAP',
    statusType: 'PENDING'
  },
  {
    id: 'RC-2046',
    title: 'Optimize Load Balancer configuration to prevent issues with NetWeaver Message Server',
    description: 'Uneven load distribution among application servers detected',
    effortType: 'low',
    status: 'deferred',
    effort: 'Low Effort',
    system: 'SAP',
    statusType: 'DEFERRED'
  },
  {
    id: 'RC-2047',
    title: 'SAP HANA High Disk Space Utilization',
    description: 'Log backup disk on sapmon-laws-5e53ed3efd5f56 is nearing full capacity',
    effortType: 'medium',
    status: 'pending',
    effort: 'Medium Effort',
    system: 'SAP',
    statusType: 'PENDING'
  },
  {
    id: 'RC-2048',
    title: 'Database Connection Pool Optimization',
    description: 'Connection pool exhaustion causing timeouts',
    effortType: 'high',
    status: 'pending',
    effort: 'High Effort',
    system: 'DB',
    statusType: 'PENDING'
  },
  {
    id: 'RC-2049',
    title: 'Infrastructure Security Patch',
    description: 'Critical security vulnerabilities need patching',
    effortType: 'high',
    status: 'workInProgress',
    effort: 'High Effort',
    system: 'Infra',
    statusType: 'WORK IN PROGRESS'
  },
  {
    id: 'RC-2050',
    title: 'Database Index Fragmentation',
    description: 'High fragmentation levels affecting query performance',
    effortType: 'medium',
    status: 'closed',
    effort: 'Medium Effort',
    system: 'DB',
    statusType: 'CLOSED'
  }
];

export const FILTER_OPTIONS = {
  sortBy: [
    { value: 'date', label: 'Sort by Date' },
    { value: 'effort', label: 'Sort by Effort' },
    { value: 'status', label: 'Sort by Status' }
  ],
  actionPack: [
    { value: 'all', label: 'Action Pack' },
    { value: 'SAP', label: 'SAP' },
    { value: 'Infra', label: 'Infrastructure' },
    { value: 'DB', label: 'Database' }
  ]
};